import React, { memo, useEffect, useState } from "react";
import Product1 from "../../assets/images/product1.jpg";
import Product2 from "../../assets/images/product2.jpg";
import MenuContainer from "../../Components/MenuContainer/MenuContainer";
import ThambnailList from "../../Components/ThambnailList/ThambnailList";
import PreviewComponet from "../../Components/PreviewComponent/PreviewComponet";
import { ManageApis } from "../../AppServices/ManageApi";
import {
  getBase64,
  getLocalStorage,
  setLocalStorage,
  suportFile,
  urlToBase64,
} from "../../Functions/Utils";
import { handleExtraction } from "../../Functions/HandleExtraction";
import { ResponseUpload } from "../../Functions/ResponseUpload";
import Loader from "../../Components/LoaderComponent/Loader";
import { useLocation, useParams } from "react-router-dom";
import AlertBox from "../../Components/AlertBox/AlertBox";
import { useStoreValues } from "../../Context/storeProvider";
import Uploadfiles from "../UploadFiles/Uploadfiles";
import ExtractingLoader from "../ExtractingLoader/ExtractingLoader";

let comp = true;
function Main({
  selectedMenu,
  isdoubleSide,
  documentSideKeys,
  headerName,
  setisToggled,
  isToggled,
}) {
  const { menuList, uploadSide, setUploadSide } = useStoreValues();
  const [thambnailDataList, setThambnailDataList] = useState([]);
  const [selectedData, setselectedData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [newLoading, setnewLoading] = useState(false);
  const [fileUploaded, setFileUploaded] = useState(false);
  const [Uploaded, setUploaded] = useState(false);
  // const [uploadSide, setUploadSide] = useState(true)
  const [Loader, setLoader] = useState(false);
  const [aofRefId, setAofRefId] = useState(null);
  const [aofResponse, setAofResponse] = useState(null);

  const side = isdoubleSide ? documentSideKeys[0]?.value : "NoSide";

  const [selectedSide, setSelectedSide] = useState(
    // isdoubleSide && documentSideKeys[0]?.value
    side
  );

  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
    isWarning: false,
  };

  useEffect(() => {
    console.log(selectedData);
  }, [selectedData]);

  const [showAlert, setShowAlert] = useState(AlertinitialValue);

  const { pathname } = useLocation();
  useEffect(() => {
    // //console.log("------------------->", selectedSide)
    if (!isdoubleSide == (selectedSide == "NoSide")) {
      selectedMenu !== "INVOICEPARSER" && handelGetUploadData();
    }
    return () => {
      setselectedData(null);
    };
  }, [selectedSide, selectedMenu]);

  useEffect(() => {
    setSelectedSide(side);
  }, [pathname]);

  useEffect(() => {
    // //console.log(menuList)
  }, [menuList]);

  const handlePreview = (image) => {
    let imageData = "";
    urlToBase64(image).then((res) => {
      imageData = res;
    });
    // //console.log(imageData)
    return imageData;
  };

  //handle getdata from backend
  const handelGetUploadData = async (fileUploaded) => {
    if (!fileUploaded) {
      // setIsLoading(true);
      setLoader(true);
    } else {
      // setLoader(true);
      setnewLoading(true);
    }

    const findMenuId = menuList.find(
      (menuItem) => menuItem.menuName === selectedMenu
    );

    const reqstData = {
      // fileType: isdoubleSide ? selectedSide : selectedMenu === "Aadhar Masking" ? "masked and unmasked" : selectedMenu,
      MenuId: `${findMenuId.id}`,
      LayoutSide: selectedSide !== "NoSide" ? selectedSide : "NoSide",
      AccountsId: `${getLocalStorage("accountsId")}`,
    };

    let responseData = await ManageApis(
      "post",
      global.GetUploadedData,
      reqstData
    );
    // //console.log("-------------------------------------->", { responseData });
    const { message, response_data, status } = responseData || {};
    if (message === "Success") {
      // setThambnailDataList(response_data.map((itm)=>({...itm,uploadedFile: urlToBase64(itm?.uploadedFile).then((res)=>{return res})})));
      // //console.log(convertDataToBase64(response_data))
      // let formateResponse = await convertDataToBase64(response_data)
      setThambnailDataList(response_data);

      if (fileUploaded) {
        setUploaded(true);
        // setFileUploaded(false)
      }
      if (!fileUploaded) {
        setLoader(false);
        //  setIsLoading(false);
      } else {
        setnewLoading(false);
      }
    } else {
      if (!fileUploaded) {
        setLoader(false);
        //  setIsLoading(false);
      } else {
        setnewLoading(false);
      }
    }
    // }
  };

  let suportFiles = [".png", ".jpeg", ".jpg", ".pdf"];
  //check status for the upload arco
  const handleFileUpload = async (e) => {
    setnewLoading(true);

    const files = e[0].originFile;
    let fileExt = files?.name?.split(".").pop();
    const base64 = await getBase64(files);
    // //console.log(files[0], fileExt, base64);

    if (files.size <= 3145728) {
      if (await suportFile(fileExt, suportFiles)) {
        try {
          if (e[0].status == "uploading") {
            let response = await handleExtraction(
              base64,
              fileExt,
              selectedMenu,
              selectedSide,
              menuList
            );
            setnewLoading(false);
            //console.log(response);
            setAofRefId(response.response_data.refId);
            setLocalStorage({ currentBase64: base64 });

            // as now evisa menu integration the error response  change for this menu so that handle here in future wants to set for common
            
            if (
              selectedMenu == "CANADIANDL" &&
              response?.response_data?.status == "Error"
            ) {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:  response?.message,
                isfalse: false,
              }));
              localStorage.removeItem("currentBase64") 
              return
            }
            if (
              response.message === "Success" &&
              response.response_data?.status != "Error" && selectedMenu == "CANADIANDL"
            ) {
              
              if(getLocalStorage('currentBase64')){
                setUploaded(true);
              }
              setUploadSide(false);
              return
            }
            if (
              selectedMenu == "EVISAEXTRACTION" &&
              response?.response_data?.status == "Error"
            ) {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:  response?.response_data?.data,
                isfalse: false,
              }));
              localStorage.removeItem("currentBase64") 
              return
            }

            if (response.status == "Error") {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: response.message,
                isfalse: false,
              }));
            }

            if (response.response_data.status == "Error") {
              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:
                  response.message == "Success"
                    ? "Your trying limit is over, please contact with support team."
                    : response.message,
                isfalse: true,
              }));
            }

            if (
              response.message === "Success" &&
              response.response_data?.status != "Error"
            ) {
              // setShowAlert((pre) => ({
              //   ...pre,
              //   show: true,
              //   message: "File Upload Successfully",
              //   isSuccess: true,
              //   isfalse: false
              // }));
              // setFileUploaded(true)
              // document.getElementById("upload").value = "";
              // setThambnailDataList((pre) => [
              //   selectedMenu === "AADHARMASKING"
              //     ? {
              //       id: Math.random(),
              //       result: response?.response_data.message,
              //       uploadedFile: base64,
              //     }
              //     : {
              //       id: Math.random(),
              //       result: JSON.stringify(response?.response_data),
              //       uploadedFile: base64,
              //     },
              //   ...pre,
              // ]);
              handelGetUploadData(true);
              // let result = await ResponseUpload(
              //   base64,
              //   response?.response_data,
              //   fileExt,
              //   isdoubleSide ? selectedSide : selectedMenu,
              //   menuList
              // );
              // //console.log('result from upload', result);
            } else {
              // //console.log("erorrr------>", response?.response_data?.message.includes("{"))

              setShowAlert((pre) => ({
                ...pre,
                show: true,
                message:
                  response.message == "Success"
                    ?
                       response?.response_data?.message
                    : response.message,
                isWarning: true,
                isfalse: false,
              }));
              // else case for response fails from ai
              document.getElementById("upload").value = "";
              setnewLoading(false);
            }
          }
        } catch (error) {
          // //console.log(error);
        }
      }
      // else case for upload image not suport
      else {
        setnewLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "File not supported",
          isfalse: false,
          isWarning: true,
        }));
      }
    } else {
      setnewLoading(false);
      setShowAlert((pre) => ({
        ...pre,
        show: true,
        message: "File size is greater than 3MB",
        isfalse: false,
        isWarning: true,
      }));
    }
  };
  const showAofDetails = async (refId) =>{
    let response = await ManageApis("post", `${global.aofValidate}`,{ refId });
    setIsLoading(true)
    setAofResponse(response);
    setIsLoading(false)
  };
  const handleDelete = async (id) => {
    setIsLoading(true);
    try {
      let response = await ManageApis("post", `${global.deleteFile}${id}`);
      setThambnailDataList((prv) => prv.filter((itm) => itm.id !== id));
      setselectedData("");
      if (response.message === "Success") {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      // //console.log(error);
      setIsLoading(false);
    }
  };
  return (
    <>
      {isLoading && <Loader />}
      {/* {!newLoading && <ExtractingLoader />} */}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        enableWarningIcon={showAlert.isWarning}
        handlecancel={() => setShowAlert(AlertinitialValue)}
      />

      {newLoading ? (
        <ExtractingLoader setisToggled={setisToggled} isToggled={isToggled} />
      ) : uploadSide ? (
        <Uploadfiles
          accept={suportFiles}
          handleFileUpload={handleFileUpload}
          dataList={thambnailDataList}
          selectedData={setselectedData}
          setUploadSide={setUploadSide}
          headerName={headerName}
          setisToggled={setisToggled}
          isToggled={isToggled}
          fileUploaded={Uploaded}
          setFileUploaded={setUploaded}
          documentSideKeys={documentSideKeys}
          setSelectedSide={setSelectedSide}
          selectedSide={selectedSide}
            Loader={Loader}
            selectedMenu={selectedMenu}
          />
          
      ) : (
        <div className="d-block d-md-flex w-100">
          {/* {!comp && */}
          <>
            {/* need to change this thumbnailList to the new upload component */}

            <MenuContainer
              headerName={headerName}
              setisToggled={setisToggled}
              isToggled={isToggled}
            >
              {/* <Uploadfiles
                handleFileUpload={handleFileUpload}
                dataList={thambnailDataList}
                selectedData={setselectedData}
                setUploadSide={setUploadSide}
                headerName={headerName}
                setisToggled={setisToggled}
                isToggled={isToggled} /> */}

              {/* <ThambnailList
                documentSideKeys={documentSideKeys}
                setSelectedSide={setSelectedSide}
                dataList={thambnailDataList}
                selectedMenu={selectedMenu}
                selectedData={setselectedData}
                handleFileUpload={handleFileUpload}
                handleDelete={handleDelete}
                selectedSide={selectedSide}
              /> */}

              <PreviewComponet
                responseData={selectedData}
                selectedMenu={selectedMenu}
                selectedSide={selectedSide}
                setUploadSide={setUploadSide}
                aofRefId = {aofRefId}
                showAofDetails = {showAofDetails}
                aofResponse = {aofResponse}
              />
            </MenuContainer>
          </>
          {/* } */}
        </div>
      )}
    </>
  );
}

export default memo(Main);
